import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_UNLOCK_USER_ACCOUNT } from "../../../config/api";
import { getAllUser } from "./management";

export const unlockUserAccount = createAsyncThunk(
  "unlockUserAccount/put",
  async ({ userId, callback, failed }, { dispatch, rejectWithValue }) => {
    try {
      const response = await Client({
        method: "PUT",
        path: `${API_UNLOCK_USER_ACCOUNT}`,
        data: {
          id: userId,
        },
      });
      toast.success("User account has been unlocked successfully.");
      callback();
      dispatch(getAllUser());
      return response?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      failed();
      toast.error(msg);
      return rejectWithValue(msg);
    }
  }
);
